<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'brochure',
};
</script>



// WEBPACK FOOTER //
// Brochure.vue?042d1218